module.exports = __webpack_public_path__ + "static/media/082-united-nations.5cfbe0c9.svg";